/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/Heart.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const Heart: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" ref={ref} {...props}>
    <path
      fill={color}
      d="M17.969 10.798q1.562-1.563 1.562-3.79 0-2.265-1.601-3.827-1.563-1.602-3.828-1.602-2.227 0-3.79 1.563L10 3.454l-.312-.312q-1.564-1.563-3.83-1.563-2.226 0-3.828 1.602Q.47 4.743.47 7.009q0 2.226 1.562 3.789l4.14 4.14 3.243 3.243a.8.8 0 0 0 .586.234q.351 0 .586-.234l3.242-3.243z"
    />
  </svg>
);
Heart.displayName = "Heart";
